// Curated changelog for the "Novedades" page — hand-maintained, one
// entry per shipped update. Add a new entry to the TOP of CHANGELOG each
// time a user-facing change goes out; CURRENT_VERSION always mirrors the
// first entry's version so the two never drift apart.
export const CHANGELOG = [
  {
    version: "15.38.3",
    date: "2026-11-03",
    items: [
      "Conector de Claude (MCP): para conectarlo ahora hay que iniciar sesión con una cuenta de personal o administrador de pflow; el conector usa su propia cuenta de solo lectura.",
    ],
  },
  {
    version: "15.38.2",
    date: "2026-10-30",
    items: [
      "Filtros de empresa: en todas las páginas, al elegir una empresa el filtro toma el color de esa empresa (el de Empresas ▸ Color).",
      "La lista desplegable de los filtros mantiene sus colores normales; solo el filtro cerrado muestra el color de la empresa.",
    ],
  },
  {
    version: "15.38.1",
    date: "2026-10-30",
    items: [
      "Pagos del Exterior (computadora): los botones de cada pago ya no se estiran; la columna Opciones tiene un ancho fijo y el archivo / pagador vuelve a verse.",
      "Barras de almacenamiento: el brillo que va de lado a lado ahora también en Pagos del Exterior, Bill of Lading y Precios Semanales de Venta.",
    ],
  },
  {
    version: "15.38.0",
    date: "2026-10-30",
    items: [
      "Compartir desde el teléfono: al compartir un PDF o una foto con la app aparece «¿A dónde va este archivo?» para elegir Retorno · Pagos del Exterior, Bill of Lading, Precios Semanales de Venta o Liquidaciones Productores; se sugiere uno según el nombre del archivo.",
      "En la página elegida aparece el archivo compartido con «Importar» para subirlo después de revisar la semana o la empresa.",
      "Celular · Pagos del Exterior: los botones de cada pago quedan dentro de la tarjeta, la fecha del pago se ve completa y la semana / año son más fáciles de tocar.",
    ],
  },
  {
    version: "15.37.3",
    date: "2026-10-30",
    items: [
      "Reportes al achicar la ventana: las vistas pasan a una segunda línea en lugar de desplazarse, los filtros muestran su texto completo y las tarjetas de resumen quedan parejas (4 o 2 × 2).",
      "Pagos Pendientes: las filas de Detalles por Empresa se adaptan al ancho — Vencido, No vencido, Cajas y Total debajo del nombre cuando no caben en una línea.",
    ],
  },
  {
    version: "15.37.2",
    date: "2026-10-30",
    items: [
      "Aviso de actualización: cuando hay una versión nueva de la app aparece «Hay una nueva versión de la app — Actualizar» abajo de la pantalla.",
      "Ventana angosta: el panel de Filtros y Acciones ya no se sale de su tarjeta (las vistas se desplazan dentro del panel y los botones bajan de línea).",
      "Dashboard del Director en ventana angosta: Cartera, Cargas, Planificación y P&G muestran su contenido completo.",
    ],
  },
  {
    version: "15.37.1",
    date: "2026-10-30",
    items: [
      "Operaciones: nueva tarjeta «Lista de Embarques» para abrir las semanas guardadas directamente desde el menú de Operaciones (con su propio permiso e icono configurable).",
    ],
  },
  {
    version: "15.37.0",
    date: "2026-10-30",
    items: [
      "Celular · Rastreo: Lista o Mapa a pantalla completa; al tocar un embarque se abre el mapa con su ruta y los detalles en un panel abajo.",
      "Celular · Embarques: cada embarque es una tarjeta con sus campos, y cada semana guardada de la Lista una tarjeta.",
      "Celular: el menú en modo burbuja ya no aparece en las páginas adaptadas al celular; se usa el ☰ de la barra superior.",
    ],
  },
  {
    version: "15.36.3",
    date: "2026-10-30",
    items: [
      "AI Analytics: el historial de preguntas guardado ya no se borra al abrir la página.",
      "AI Analytics: al llegar una respuesta solo se desplaza el panel de la respuesta, no toda la página.",
      "AI Analytics: los atajos de semana bajo la pregunta pasan a la línea siguiente en lugar de desplazarse de lado.",
    ],
  },
  {
    version: "15.36.2",
    date: "2026-10-30",
    items: [
      "Préstamos Financieros: solo se puede eliminar el registro más reciente de cada préstamo, para que los registros siguientes no cambien; para quitar una semana anterior se eliminan primero las más recientes.",
      "Préstamos: «Eliminar año» solo funciona en el último año de sus préstamos y borra del más reciente hacia atrás.",
      "Préstamos Financieros: cada registro tiene el menú ⋮ (Duplicar / Eliminar) como las demás tablas, y los botones usan los iconos de Configuración.",
      "Celular · Préstamos Financieros y su Lista: cada registro es una tarjeta con sus campos de dos en dos, y cada año de la Lista una tarjeta.",
    ],
  },
  {
    version: "15.36.1",
    date: "2026-10-29",
    items: [
      "Celular · Novedades: la versión actual debajo del título y cada versión como una tarjeta compacta.",
      "Celular · Mi perfil: las tarjetas apiladas, Usuario / Rol / ID en una fila, campos que no hacen zoom y «Guardar cambios» a todo el ancho.",
    ],
  },
  {
    version: "15.36.0",
    date: "2026-10-29",
    items: [
      "Inicio: los accesos rápidos usan los iconos configurados en Configuración.",
      "Celular · Inicio: saludo compacto con la fecha, la semana y la hora, y los accesos rápidos como mosaicos de dos en dos.",
      "Celular · Gestión Semanal: Compra Fruta, Precios de Venta, Costos, Liquidaciones, sus listas y el Cierre Semanal se adaptan al celular — cada línea es una tarjeta con sus campos, cada semana guardada una tarjeta, y en Cierre Semanal se desliza de empresa en empresa.",
      "Celular · filtros: los botones de filtro (Empresas, Condición, Marca, Productor…) del mismo tamaño, con su etiqueta sobre el valor; la empresa y Agregar en una fila; «Copiar de» en Costos en su propio bloque.",
    ],
  },
  {
    version: "15.35.4",
    date: "2026-10-29",
    items: [
      "Usuarios: los filtros de rol y estado ocupan todo el ancho de la fila.",
      "Usuarios: Correo y WhatsApp muestran cada contacto con su interruptor de alertas debajo, alineados; el número de WhatsApp se ve como texto y se edita con un clic.",
      "Usuarios: la columna Acceso cuenta «permisos» (páginas y funciones) en lugar de «páginas».",
    ],
  },
  {
    version: "15.35.3",
    date: "2026-10-29",
    items: [
      "Celular · Dashboard del Director: cada Detalle (Requiere tu atención, Cartera, Cargas, P&G, Planificación, Compras) se abre de lado en pantalla completa.",
      "Celular · Dashboard del Director: Cartera y Cargas muestran solo las 5 primeras filas; «Ver …» abre la lista completa.",
    ],
  },
  {
    version: "15.35.2",
    date: "2026-10-29",
    items: [
      "Celular · Pagos Pendientes: al entrar solo se ven los filtros y las tarjetas de resumen; «Gráfico» abre el gráfico de lado en pantalla completa y «Detalles por Empresa» muestra la lista de empresas debajo.",
      "Celular · Resumen Cuadro: al entrar solo se ven los filtros; al elegir Totales, Precios o Cajas se abre de lado en pantalla completa con sus gráficos y botones.",
    ],
  },
  {
    version: "15.35.1",
    date: "2026-10-29",
    items: [
      "Celular · Resumen Cartera: al entrar solo se ven los filtros y las tarjetas de resumen; al elegir una vista se abre de lado en pantalla completa, con su gráfico y todos sus botones.",
      "Celular · Resumen Cartera: en los gráficos, las empresas se muestran con 3 letras y los clientes con hasta 10 caracteres.",
    ],
  },
  {
    version: "15.35.0",
    date: "2026-10-29",
    items: [
      "Celular · Reportes: cada gráfico de Resumen Cartera, Pagos Pendientes y Resumen Cuadro tiene el botón «Ver en horizontal», que lo abre en pantalla completa y de lado, con los nombres completos y sin apretarse.",
    ],
  },
  {
    version: "15.34.1",
    date: "2026-10-29",
    items: [
      "Packing Lists: la lista de clientes muestra el nombre del cliente en lugar del nombre de facturación.",
    ],
  },
  {
    version: "15.34.0",
    date: "2026-10-29",
    items: [
      "Empresas: cada empresa elige su tipo de identificación, RUC (solo números) o Tax ID (letras, números y guiones, para empresas del exterior). Los RUC existentes se mantienen igual.",
      "Facturas y Packing Lists muestran «RUC:» o «Tax ID:» según el tipo de la empresa.",
    ],
  },
  {
    version: "15.33.2",
    date: "2026-10-29",
    items: [
      "Empresas: el formulario de Agregar / Editar es más ancho y compacto, con los campos en columnas y Solo facturación, Color, Cuentas Bancarias, Logo, Sello y Firma como tarjetas ordenadas, para que todo quepa en la pantalla.",
    ],
  },
  {
    version: "15.33.1",
    date: "2026-10-28",
    items: [
      "Celular · Reportes: los gráficos usan todo el ancho, con números cortos a los lados ($24M, 500K) y sin los títulos girados; las empresas se muestran con 3 letras y los clientes recortados (el nombre completo sigue en el detalle al tocar).",
      "Celular · Reportes: los botones de gráfico en una línea y los filtros uno por fila, con sus textos completos.",
    ],
  },
  {
    version: "15.33.0",
    date: "2026-10-28",
    items: [
      "Versión para celular de Reportes: Dashboard del Director, Resumen Cartera, Pagos Pendientes y Resumen Cuadro, con los filtros y botones del mismo tamaño, gráficos ajustados y tablas que se deslizan de lado.",
      "Celular · Pagos Pendientes: cada empresa y cada cliente como tarjeta con sus montos visibles; en el detalle, Cerrar arriba a la derecha y Resumen / PDF / Excel parejos.",
      "Pagos Pendientes: los nombres de clientes de más de 25 letras se cortan y el nombre completo aparece al pasar el cursor.",
    ],
  },
  {
    version: "15.32.2",
    date: "2026-10-28",
    items: [
      "Celular: en las tarjetas con varios botones (como Grupos de WhatsApp) Editar y Eliminar quedan abajo, a lo ancho y con su nombre, sin tapar el nombre del grupo.",
    ],
  },
  {
    version: "15.32.1",
    date: "2026-10-28",
    items: [
      "Celular: la pantalla de carga se ve como una página de celular (tarjetas de dos en dos y la tabla como tarjetas, sin bordes), y al abrir la app ya no cambia de tamaño.",
      "Celular: las Vistas de Clientes y Empresas de dos en dos, los filtros de empresa a lo ancho, y en Usuarios el correo y el WhatsApp junto a su alerta.",
    ],
  },
  {
    version: "15.32.0",
    date: "2026-10-28",
    items: [
      "Versión para celular de todas las páginas de Admin (Configuración, Empresas, Cuentas Bancarias, Clientes, Condiciones, Productos, Tipos, Productores, Marcas, Embarque, Proveedores, Grupos de WhatsApp y Usuarios): las tablas se ven como tarjetas con el nombre como título, y los formularios en una columna.",
      "Embarque y Proveedores: la selección de tabla ahora está en Filtros y Acciones como «Vista», en computadora y celular.",
    ],
  },
  {
    version: "15.31.1",
    date: "2026-10-28",
    items: [
      "Estado de Cuenta: la fila de totales dice «TOTAL» en su primera columna, y en el celular queda fija con la columna Semana/Año al deslizar la tabla.",
    ],
  },
  {
    version: "15.31.0",
    date: "2026-10-28",
    items: [
      "Versión para celular de Estado de Cuenta: filtros y botones a lo ancho, los modos Cliente / Semana / Pagos en una fila, y la tabla compacta que se desliza de lado con la columna Semana/Año fija.",
      "Estado de Cuenta: todo el contenido de la tabla va centrado, y el modo «Semana (Todos)» ahora se llama «Semana».",
      "Celular: las ventanas que se abren desde la fila de botones (como Deuda Anterior) ya no quedan escondidas arriba, y el botón Columnas ocupa su espacio.",
    ],
  },
  {
    version: "15.30.1",
    date: "2026-10-28",
    items: [
      "Celular · Facturación: las ventanas (formularios, vistas previas, Exportar, Propiedades, Eliminar y el visor de PDF) ocupan el ancho del teléfono, con los campos en una columna y los botones a lo ancho.",
      "Celular · Importar desde Slack: Año y Semana lado a lado, Buscar a lo ancho, archivos más fáciles de marcar y Cancelar / Importar parejos abajo.",
    ],
  },
  {
    version: "15.30.0",
    date: "2026-10-28",
    items: [
      "Facturas y Packing Lists guardados: nuevo botón «Actividad Reciente» con lo agregado, modificado y eliminado recientemente (quién y cuándo); al tocar uno se abre. Desde ahora se registra quién elimina cada factura o packing list.",
    ],
  },
  {
    version: "15.29.2",
    date: "2026-10-28",
    items: [
      "Celular: el botón ☰ del Facturador y del Packing List se oculta mientras el menú principal está abierto, y los filtros de Semana y Año de Facturas ya no se enciman.",
    ],
  },
  {
    version: "15.29.1",
    date: "2026-10-28",
    items: [
      "Celular · Facturación: Filtros y Acciones más ordenados (controles del mismo alto, sin botones sueltos a medio ancho) y tarjetas de las tablas con más espacio.",
      "Celular · Facturador Comercial y Packing List: el botón ☰ queda abajo al centro y abre con un toque; las secciones salen en medio círculo con más espacio; la vista previa del Packing List queda centrada y a lo ancho de la pantalla.",
    ],
  },
  {
    version: "15.29.0",
    date: "2026-10-28",
    items: [
      "Versión para celular de todas las páginas de Facturación: Facturas, Packing Lists guardados, Bill of Lading y Precios Semanales de Venta muestran cada fila como una tarjeta, con los filtros y botones a lo ancho del teléfono.",
      "Facturador Comercial y Packing List en el celular: se abren en el modo Compacto, con la vista previa a lo ancho de la pantalla y las secciones en el menú ☰ (abajo a la derecha; al abrirlo se centra para que quepan todas las burbujas).",
    ],
  },
  {
    version: "15.28.0",
    date: "2026-10-28",
    items: [
      "Versión para celular del inicio de sesión, la página principal y las páginas de sección (Admin, Estados de Cuenta, Reportes, Cierres, Facturación, Control de Costos, Inventario, Finanzas, Operaciones y APIs): ocupan el ancho del teléfono, con el menú ☰ arriba y las secciones en dos columnas.",
    ],
  },
  {
    version: "15.27.3",
    date: "2026-10-28",
    items: [
      "Cuadro de Precios: el botón «Avisar Precios» ahora se llama «Aprobar precios».",
    ],
  },
  {
    version: "15.27.2",
    date: "2026-10-27",
    items: [
      "Clientes: al eliminar un cliente, cada tipo de registro vinculado muestra también las semanas a las que pertenece (por ejemplo «2026: S1–S9»).",
    ],
  },
  {
    version: "15.27.1",
    date: "2026-10-27",
    items: [
      "Clientes: antes de eliminar un cliente, la ventana muestra lo que tiene vinculado: lo que se eliminará con él (transacciones, retornos) y lo que se conserva pero queda sin cliente (facturas, embarques, packing lists, B/L, etc.).",
    ],
  },
  {
    version: "15.27.0",
    date: "2026-10-27",
    items: [
      "Usuarios: cada usuario con su foto, nombre, @usuario y rol en una sola celda, con un punto verde si está en línea; el correo junto a su alerta.",
      "Usuarios: tarjetas de resumen (usuarios, roles, en línea ahora, sin actividad 30+ días) que filtran la tabla, y filtros por rol y estado.",
      "Usuarios: Desactivar / Activar (no puede iniciar sesión pero conserva su historial) y Restablecer contraseña desde el menú ⋮, con íconos configurables en Ajustes.",
      "Usuarios: la última actividad muestra la IP y el dispositivo del último inicio de sesión; nueva columna Acceso con cuántas páginas puede abrir cada uno; Exportar Excel con los usuarios y sus permisos por página.",
    ],
  },
  {
    version: "15.26.0",
    date: "2026-10-27",
    items: [
      "Catálogo ▸ Proveedores: nuevo campo RUC / Cédula (en la tabla, el formulario y la búsqueda), y se cargaron los 35 proveedores activos de 2026 del ERP con su RUC.",
      "Catálogo: la opción Bodegas muestra cuántas hay, como las demás secciones.",
      "Conector de Claude (MCP): ahora también puede consultar Inventario (existencias, movimientos, órdenes, recepciones, artículos, proveedores y bodegas), Préstamos, Pagos del Exterior, productores con sus fincas y packing lists.",
    ],
  },
  {
    version: "15.25.2",
    date: "2026-10-27",
    items: [
      "Retorno · Pagos del Exterior: el filtro de Semana se abre en la semana actual, y Limpiar Filtros vuelve al año y la semana actuales.",
    ],
  },
  {
    version: "15.25.1",
    date: "2026-10-27",
    items: [
      "Ajustes: «Packing Lists» aparece en los íconos de Facturación y en los permisos de usuario (por defecto sigue el permiso de Packing List); en los permisos de Inventario «Artículos y Proveedores» ahora se llama Catálogo.",
    ],
  },
  {
    version: "15.25.0",
    date: "2026-10-27",
    items: [
      "Facturación: nueva opción «Packing Lists» en el menú, que abre directo los packing lists guardados.",
      "Packing Lists guardados: espacio parejo entre las secciones, la barra de disco con el brillo de Facturas, el buscador ocupa toda la fila y la columna Booking ya no se muestra.",
      "Packing List: «Diseño» y «Sello» juntos en «Diseño y sello» como en el Facturador; las etiquetas verdes con más espacio y el botón para eliminar un contenedor con el ícono de Ajustes, centrado.",
      "Facturas: espacio parejo entre las secciones y los filtros de Semana y Año con el mismo estilo de lista que Estado de Cuenta.",
      "Estado de Cuenta: menos espacio entre los filtros y el aviso cuando no hay datos o se están cargando.",
      "Facturador Comercial: las etiquetas verdes del cliente (dirección y plazo de pago) con más espacio.",
      "Inventario: al crear una bodega se elige la empresa en el mismo formulario.",
    ],
  },
  {
    version: "15.24.1",
    date: "2026-10-27",
    items: [
      "Inventario: los formularios toman el color de la empresa elegida (borde, encabezado con el nombre de la empresa y pie), y cambian al elegir otra.",
      "Menú burbuja: ahora se abre como un círculo que crece desde la burbuja y se cierra encogiéndose de vuelta en ella.",
    ],
  },
  {
    version: "15.24.0",
    date: "2026-10-26",
    items: [
      "Inventario: botón ❓ Ayuda en cada página, con qué hace cada una y cómo se usa, en el orden del flujo (catálogo, saldos iniciales, órdenes, IB, movimientos y existencias).",
      "«Artículos, Proveedores y Bodegas» ahora se llama Catálogo; Existencias y Catálogo ya no tienen los botones para saltar a otras páginas.",
      "Saldos iniciales: más ancho; primero la Empresa y luego Categoría, Grupo y Subgrupo; cada artículo muestra su ID contable y nombre, y tiene Contenido c/u como en las órdenes de compra, con ＋ para cargar varios contenidos del mismo artículo.",
      "Registrar movimiento: más ancho, con la Semana operativa, cuántos artículos tiene cada empresa y cuánto hay en existencia en cada bodega; los contenidos en existencia y el total van en una barra, y los artículos se muestran como en las órdenes de compra.",
      "Órdenes de Compra: una línea nueva recuerda la Categoría de la anterior, y cada línea se puede duplicar.",
      "Existencias: tarjeta «En existencia» con el total disponible; la columna Existencia sin unidad, y «+N en otras bodegas» en lugar de «empresa: N».",
    ],
  },
  {
    version: "15.23.2",
    date: "2026-10-26",
    items: [
      "Menú burbuja: la animación es más rápida, y manteniendo presionada la burbuja (sin moverla) el menú vuelve a la barra lateral.",
    ],
  },
  {
    version: "15.23.1",
    date: "2026-10-26",
    items: [
      "Precios de compra: el código de la finca usa la semana y el día del día siguiente a la creación de la línea.",
      "Menú burbuja: se abre como una píldora que sale de la burbuja y luego baja, con los elementos apareciendo uno a uno; se cierra al revés. Ya no muestra el logo arriba.",
    ],
  },
  {
    version: "15.23.0",
    date: "2026-10-26",
    items: [
      "Órdenes de Compra: cada fila se colorea según su estado; en el formulario cada artículo es una tarjeta con Categoría, Grupo, Subgrupo y Artículo arriba, y Contenido, Cantidad, Precio, IVA y el total de la línea abajo.",
      "Registrar movimiento: formulario más ancho y ordenado (sin desplazarse), tipo de movimiento como selector, y el artículo se elige por Categoría → Grupo → Subgrupo → Artículo, solo entre los de la empresa elegida.",
      "Saldos iniciales: se elige la Categoría y el Grupo (y si quieres el Subgrupo) para ver sus artículos.",
    ],
  },
  {
    version: "15.22.0",
    date: "2026-10-25",
    items: [
      "Inventario: las páginas usan el mismo diseño que el resto de la app — menú «Opciones ⋮» en cada fila, buscador y filtros en forma de píldora que se resaltan al filtrar y ocupan todo el ancho.",
      "Órdenes de Compra: tarjetas de resumen (semana, órdenes, total, por recibir); Año y Semana primero; la columna Artículos muestra cuántos son y el detalle al pasar el cursor.",
      "Recepciones (IB): Vista «Por recibir» / «IB generados», filtro de Año y Semana (la actual por defecto), artículos recibidos al pasar el cursor y exportar cada IB a PDF.",
      "Movimientos: Año y Semana primero (la actual por defecto) y la cantidad sin la unidad.",
    ],
  },
  {
    version: "15.21.0",
    date: "2026-10-24",
    items: [
      "Productores: cada productor tiene sus Fincas, cada una con su Código productor (3 dígitos) y Código hacienda (2 dígitos); exportar la tabla a PDF.",
      "Packing List: el Farm Code se arma solo con la semana y el día de la fecha del contenedor (Domingo = 1, la semana va de domingo a sábado) + productor + hacienda, p. ej. 30110101; se elige la Finca del productor.",
      "Precios de compra: columna «Finca · código» con el código completo (semana y día de la fecha de creación de la línea).",
      "Órdenes de Compra: cada línea tiene su Contenido (p. ej. zuncho de 10 kg o de 5 kg), que viene del artículo y se puede cambiar.",
      "Existencias: el stock se lleva por contenido — cada uno con su existencia, costo promedio y valor; entradas, salidas, transferencias y conteos eligen el contenido.",
      "Inventario: nuevo orden del menú (Artículos, Órdenes de Compra, Recepciones, Movimientos, Existencias).",
      "Estado de Cuenta: las notas de crédito encuentran su factura aunque el número esté escrito con otros espacios, o se aplican a la única transacción sin factura de su semana.",
      "La pantalla de carga ya no se ve negra al recargar y tiene el mismo ancho que la página.",
    ],
  },
  {
    version: "15.20.1",
    date: "2026-10-22",
    items: [
      "Inventario: los artículos de Cartón vuelven a llamarse con su marca y tipo de caja (p. ej. «FONDO GROBANA AZUL 22XU»); en listas y selectores ya no se repiten la marca y la caja cuando el nombre ya las incluye.",
    ],
  },
  {
    version: "15.20.0",
    date: "2026-10-22",
    items: [
      "Inventario: «Propiedades» (ℹ️) en artículos, proveedores, bodegas, categorías, grupos, subgrupos, unidades, órdenes de compra, movimientos y recepciones: quién lo creó o editó y cuándo.",
      "Inventario: categorías, grupos, subgrupos y unidades en orden alfabético (sin flechas para reordenar).",
      "Órdenes de Compra: el PDF ya no tiene la columna Unidad (el contenido va en la descripción) y usa la Presentación del artículo como nombre cuando la tiene.",
    ],
  },
  {
    version: "15.19.1",
    date: "2026-10-22",
    items: [
      "Cierre semanal: los «Detalles» de Facturación, Compra y Costos usan el color de la empresa y muestran la semana en el encabezado.",
      "Cierre semanal: el detalle de Costos es más ancho (Línea Naviera), resalta los costos y el total, y tiene un diseño más limpio.",
    ],
  },
  {
    version: "15.19.0",
    date: "2026-10-22",
    items: [
      "Pagos Pendientes: diseño compacto como Resumen Cartera, con «Filtros y Acciones», vistas Detalles por Empresa / Gráfico que llenan la pantalla, y botones Actualizar, Exportar y Enviar a la vista.",
      "Pagos Pendientes: cada empresa es una fila con Vencido, No vencido, Cajas y Total; al hacer clic se abre su detalle a pantalla completa (con Resumen, PDF y Excel). Las empresas de solo facturación no aparecen en Detalles por Empresa.",
    ],
  },
  {
    version: "15.18.0",
    date: "2026-10-22",
    items: [
      "Préstamos Financieros: varios préstamos del mismo tipo en el mismo año, cada uno con su nombre, capital inicial, interés y deuda; «Nuevo préstamo» y, con todos los préstamos a la vista, «Nuevo registro» pregunta a cuál agregar la semana.",
      "Dashboard del Director: los Intereses del P&G suman todos los préstamos; al pasar el cursor se ve cada préstamo.",
      "Precios de Venta y Embarques vuelven a mostrar las filas con el color de cada empresa; la pantalla de carga ya no tiene bordes grises.",
    ],
  },
  {
    version: "15.17.0",
    date: "2026-10-22",
    items: [
      "Diseño: toda la aplicación en español y con un solo formato de dinero ($1,234.56); Logística ya no muestra pesos colombianos.",
      "Diseño: las páginas antiguas usan el panel «Filtros y Acciones», las ventanas comunes con 💾 Guardar, mensajes en la página en lugar de alertas, y colores de acción uniformes (crear verde, exportar rojo, importar cian).",
      "Diseño: catálogos (Marcas, Tipos de caja, Productores, Condiciones, Usuarios…) con el mismo aspecto; tablas con montos alineados a la derecha y totales al pie; títulos iguales al menú; modo oscuro corregido.",
      "Cierre semanal: la Facturación muestra el término de entrega y el flete de cada línea, y el «Flete incluido» en la tarjeta.",
    ],
  },
  {
    version: "15.16.1",
    date: "2026-10-21",
    items: [
      "Diseño: mensajes de carga en español y sin dejar la página en blanco al actualizar; el menú ⋮ de las tablas de Logística ya abre junto a su botón al desplazarse.",
      "Diseño: línea de encabezado en las listas, migas de pan en Costos, Perfil, Novedades y Rastreo, textos «Todos los…» y «— elegir —» uniformes, «Exento», y ya no se dice «costos FOB» en el Cierre semanal.",
      "Diseño: tarjetas de resumen de Inventario con su color, filas de Clientes sin el verde general, y vista previa de exportación de Embarques en modo oscuro.",
    ],
  },
  {
    version: "15.16.0",
    date: "2026-10-21",
    items: [
      "Inventario: nuevo campo Contenido junto a la unidad (p. ej. 375 mL, 2 m, 10 kg); la orden de compra muestra el total (3 × 375 mL = 1,125 mL).",
      "Inventario: varios artículos pueden llamarse igual si cambian marca, tipo de caja o presentación; en listas y selectores se ven como «FONDO · GROBANA AZUL · 22XU».",
      "Inventario: el artículo solo guarda el tipo de IVA; el porcentaje se escribe en cada línea de la orden de compra (obligatorio para artículos Imponibles).",
      "Órdenes de Compra: formulario más ancho en dos columnas (orden a la izquierda, Concepto y Notas a la derecha); se elige Empresa → Grupo → Subgrupo → Artículo; las empresas muestran cuántos artículos tienen.",
      "Órdenes de Compra: filtro de una sola semana (la actual por defecto) y PDF con el logo y el color de la empresa, sin dirección y con mejor espaciado.",
    ],
  },
  {
    version: "15.15.0",
    date: "2026-10-21",
    items: [
      "Analítica ▸ Semanas para cubrir: al pasar el cursor sobre Facturación o Pagos se ve el detalle (transacciones por cliente / cada pago con su fecha); la vista solo usa Empresa y Año.",
      "Se retiró Snapshot de Cartera (página, API y datos guardados): su enlace ahora abre Analítica ▸ Semanas para cubrir.",
    ],
  },
  {
    version: "15.14.0",
    date: "2026-10-21",
    items: [
      "Analítica: nueva vista «Semanas para cubrir» con Facturación, Cartera Corriente (acumulada desde la semana 1 con los pagos fechados hasta esa semana), Pagos por fecha y Semanas para cubrir; avisa de los pagos sin fecha.",
    ],
  },
  {
    version: "15.13.3",
    date: "2026-10-20",
    items: [
      "Snapshot de Cartera: la fila Total de los Snapshots Guardados muestra el promedio de días para cubrir la cartera.",
    ],
  },
  {
    version: "15.13.2",
    date: "2026-10-20",
    items: [
      "Snapshot de Cartera: los Snapshots Guardados muestran todas las semanas del año por defecto; lo que guardas desde la vista previa aparece al momento.",
    ],
  },
  {
    version: "15.13.1",
    date: "2026-10-20",
    items: [
      "Snapshot de Cartera: nueva columna «Semanas para cubrir» en los guardados: cuántas semanas de Retorno (de esa semana hacia atrás) hacen falta para cubrir la Cartera Corriente de cada semana.",
    ],
  },
  {
    version: "15.13.0",
    date: "2026-10-20",
    items: [
      "Órdenes de Compra: IVA por línea (sale del artículo y se puede cambiar en la orden), con Subtotal, IVA y Total en el formulario, la lista y el PDF.",
      "Órdenes de Compra: el PDF muestra el ID contable y la Presentación / Marca / Tipo de caja de cada artículo; el selector de artículos muestra ID contable y presentación, y lista los artículos de la empresa elegida en la orden.",
      "Snapshot de Cartera: las semanas empiezan en la semana anterior (ISO); la vista previa y los guardados muestran la suma de todas las empresas, con opción de desglosar por empresa, y mejor espaciado.",
    ],
  },
  {
    version: "15.12.1",
    date: "2026-10-19",
    items: [
      "Inventario: vuelve el campo Descripción del artículo (al final del formulario).",
      "Inventario ▸ Artículos: la tabla agrupa Artículo, Descripción y Marca / Caja / Presentación en una columna, y Categoría, Grupo y Subgrupo en otra.",
    ],
  },
  {
    version: "15.12.0",
    date: "2026-10-18",
    items: [
      "Inventario: nuevo nivel Categoría por encima de los Grupos (Categoría → Grupo → Subgrupo), con su propia sección; en el artículo se elige primero la categoría.",
      "Inventario: cada Subgrupo indica qué campos usan sus artículos (Marca, Tipo de caja, Presentación); el formulario del artículo solo muestra esos, al final del formulario.",
      "Inventario: la Presentación ahora se escribe a mano en el artículo; se quitaron Tarifa de IVA y Descripción del formulario.",
    ],
  },
  {
    version: "15.11.0",
    date: "2026-10-16",
    items: [
      "Inventario, formulario del artículo: ID de artículo e ID contable, Empresa (obligatoria), IVA (IVA 0%, Imponible, Excento) con su tarifa, Presentación y Descripción; se quitaron Proveedor, Existencia mínima y Marca.",
      "Inventario: los Tipos ahora se llaman Grupos y los Grupos, Subgrupos; nueva lista de Presentaciones; las unidades de medida guardan su nombre tal como se escribe (por ejemplo \"Mililitro (mL)\").",
      "Existencias, Movimientos y Órdenes de Compra muestran solo los artículos de la empresa elegida.",
    ],
  },
  {
    version: "15.10.0",
    date: "2026-10-16",
    items: [
      "Retorno: vuelve el botón \"Importar de Slack\", que lee los comprobantes de pago de la semana desde el canal de Slack para revisarlos y guardarlos como retornos (junto a Pagos del Exterior).",
      "Configuración > Slack: vuelve el campo del canal de pagos (Payments channel ID) que usa esa importación.",
    ],
  },
  {
    version: "15.9.1",
    date: "2026-10-15",
    items: [
      "Arreglado: en el teléfono la pantalla de inicio de sesión salía completamente negra con el tema de Halloween (el Modo rápido ocultaba también el cuadro de ingreso).",
      "Dashboard del Director, P&G: la columna Deuda ahora es Intereses (los intereses de los Préstamos Financieros de esa semana) y Utilidad − Deuda pasa a llamarse Utilidad neta (utilidad menos intereses).",
    ],
  },
  {
    version: "15.9.0",
    date: "2026-10-15",
    items: [
      "Dashboard del Director, P&G semana a semana: nuevas columnas Deuda (la deuda de los Préstamos Financieros en esa misma semana) y Utilidad − Deuda.",
    ],
  },
  {
    version: "15.8.1",
    date: "2026-10-15",
    items: [
      "Lista de Préstamos: ahora agrupa por año (una línea por año con su capital, interés, pagos y deuda al cierre), sin columnas de semana, mes ni tipos.",
      "Préstamos Financieros: descripción más simple.",
    ],
  },
  {
    version: "15.8.0",
    date: "2026-10-15",
    items: [
      "Nueva página Finanzas > Préstamos Financieros: una fila por semana (interés bancario o interés capital) que se llena directamente en la tabla, con la fecha, su semana y mes, el capital inicial, abonos de capital (+/−), la tasa, el pago y su fecha. El interés (capital × tasa ÷ 52) y la deuda (deuda anterior + interés − pago) se calculan solos. Botón para duplicar una fila a la semana siguiente y filtros por año, mes, semana y tipo.",
      "Nueva página Lista de Préstamos: una línea por semana con su capital, interés, pagos y deuda al cierre, con Ver, Editar, Exportar Excel y Eliminar.",
      "Nuevos permisos de usuario para Préstamos Financieros y su Lista.",
    ],
  },
  {
    version: "15.7.2",
    date: "2026-10-15",
    items: [
      "Pagos del Exterior: al subir un comprobante, cada pago se asigna automáticamente a la semana de su fecha (ya no hay que elegir \"Asignar a\"); la semana y el año de cada fila se pueden editar en la columna Sem.",
      "Retorno: al cerrar el formulario de Editar Retorno, \"Nuevo Retorno\" vuelve a abrir vacío.",
    ],
  },
  {
    version: "15.7.1",
    date: "2026-10-15",
    items: [
      "Retorno: el formulario de Nuevo / Editar Retorno tiene el mismo estilo que Pagos del Exterior: una línea por pago (Tentativo, Acreditado, fecha, semana y año asignados), solo las líneas en uso con \"＋ Agregar otro pago\" y ✕, y los pagos pendientes del cliente al lado.",
      "Pagos del Exterior: nuevo botón \"Enviar todo a Retorno\" que envía todos los pagos completos del filtro actual.",
    ],
  },
  {
    version: "15.7.0",
    date: "2026-10-15",
    items: [
      "Pagos del Exterior: cada pago tiene su propia Semana / Año asignado, que pasan a Retorno con ese pago (vacío = la semana del pago).",
      "Pagos del Exterior: botón \"Separar\" para deshacer una unión hecha con \"Unir con…\"; el pago unido vuelve a su propia fila con sus pagos y su archivo.",
      "Pagos del Exterior: solo se muestran las líneas de pago en uso, con \"＋ Agregar otro pago\" para abrir otra y ✕ para quitar una vacía; Archivo / Pagador y Empresa / Cliente van juntos en una columna, todo alineado por fila, y los campos numéricos ya no tienen flechas.",
    ],
  },
  {
    version: "15.6.0",
    date: "2026-10-15",
    items: [
      "Pagos del Exterior: nueva opción \"Unir con…\" para juntar dos comprobantes con la misma empresa y cliente en una sola fila; sus pagos y archivos quedan juntos y se envían a Retorno como un solo registro.",
      "Pagos del Exterior: nueva sección de almacenamiento que muestra cuánto espacio ocupan los comprobantes y cuánto queda libre en el servidor.",
    ],
  },
  {
    version: "15.5.2",
    date: "2026-10-15",
    items: [
      "Configuración > Íconos: al cambiar o restablecer un ícono, el nuevo se ve de inmediato (antes el navegador podía seguir mostrando la imagen anterior guardada en caché).",
    ],
  },
  {
    version: "15.5.1",
    date: "2026-10-15",
    items: [
      "Configuración > Íconos: nuevos grupos Finanzas (Retorno) e Inventario (Existencias, Movimientos, Órdenes de Compra, Recepciones y Artículos); Estados de Cuenta ahora muestra su página Estado de Cuenta.",
    ],
  },
  {
    version: "15.5.0",
    date: "2026-10-15",
    items: [
      "Nueva sección Inventario: existencias por empresa y bodega de cartón, pallets, químicos, etiquetas, protectores de borde y stickers, calculadas a partir de los movimientos (entradas, salidas, ajustes, transferencias y conteos físicos), con costo promedio y valor del inventario.",
      "Órdenes de Compra de materiales con aprobación, envío al proveedor y recepción (parcial o total) que suma las existencias automáticamente; la semana operativa y la fecha se llenan solas.",
      "Artículos, Proveedores y Bodegas: cada artículo tiene ID, tipo, grupo, marca y unidad de medida; los Tipos, Grupos y Unidades se administran desde la misma página, con un panel de Filtros y Acciones.",
      "Nuevos permisos de usuario para cada página del Inventario y para aprobar órdenes de compra.",
    ],
  },
  {
    version: "15.4.0",
    date: "2026-10-14",
    items: [
      "Cierre Semanal: nuevos campos \"Ajuste de precio de contrato\" y \"Ajuste\" debajo de Asumidos en Costos. Se suman al Total Costos (un valor negativo lo reduce) y salen en la exportación a Excel.",
      "Cierre Semanal: nuevo cuadro \"Observación\" debajo de Costos para dejar una nota de la semana. Se guarda automáticamente por empresa.",
    ],
  },
  {
    version: "15.3.2",
    date: "2026-10-13",
    items: [
      "Retorno en el teléfono: el formulario de Nuevo / Editar Retorno ahora es de una sola columna (Empresa y Cliente a todo el ancho, Año y Semana juntos, montos y fechas en pares, campos y botones grandes).",
    ],
  },
  {
    version: "15.3.1",
    date: "2026-10-13",
    items: [
      "Retorno en el teléfono: cada retorno se muestra como una tarjeta (empresa, cliente, tentativo y acreditado) en lugar de una tabla ancha; barra superior solo con el botón del menú; Filtros y Acciones con filtros en dos columnas y botones grandes.",
      "Pagos del Exterior en el teléfono: tarjetas por pagador con estado y semana arriba, y los pagos apilados (se muestran los llenos más uno vacío, con el botón \"Agregar otro pago\"); botones Ver, Enviar a Retorno, Releer y Eliminar en cuadrícula.",
    ],
  },
  {
    version: "15.3.0",
    date: "2026-10-13",
    items: [
      "La aplicación carga mucho más rápido: cada página se descarga solo la primera vez que se abre (el archivo inicial pasó de 5.5 MB a 0.35 MB).",
      "Nuevo \"Modo rápido\": en teléfonos y equipos lentos se apagan los efectos decorativos (nubes, adornos de temporada, confeti y desenfoques) para que todo vaya más fluido. Es automático en el teléfono y se puede cambiar en Configuración > Rendimiento.",
    ],
  },
  {
    version: "15.2.0",
    date: "2026-10-13",
    items: [
      "Retorno en el teléfono: la página ahora usa el ancho real de la pantalla (antes se veía todo pequeño, como en una computadora), con barra superior y menú lateral deslizable (☰), tarjetas en una sola columna y márgenes más chicos. Las demás páginas siguen igual por ahora.",
    ],
  },
  {
    version: "15.1.1",
    date: "2026-10-13",
    items: [
      "Compartir hacia la app: se corrigió que el archivo compartido desde el teléfono no aparecía en Pagos del Exterior para subirlo.",
    ],
  },
  {
    version: "15.1.0",
    date: "2026-10-13",
    items: [
      "Compartir hacia la app (Android): con la app instalada en el teléfono, \"Sunrise Fruit\" aparece en el menú Compartir. Al compartir un PDF o una imagen (por ejemplo desde WhatsApp o el correo), se abre Retorno > Pagos del Exterior con el archivo listo para subir y que el bot lo lea. Desinstala y vuelve a instalar la app para activarlo.",
    ],
  },
  {
    version: "15.0.1",
    date: "2026-10-13",
    items: [
      "Instalar la app en el teléfono: ahora se muestra como \"Sunrise Fruit\" con el ícono del banano (antes aparecía \"Create React App Sample\" con el logo de React). Si ya la tenías instalada, desinstálala y vuelve a instalarla.",
    ],
  },
  {
    version: "15.0.0",
    date: "2026-10-13",
    items: [
      "Nueva sección Finanzas en el menú. La página Retorno se movió de Estados de Cuenta a Finanzas (el permiso sigue siendo el mismo).",
      "Retorno: el botón \"Pagos de Slack\" ahora es \"Pagos del Exterior\". Los comprobantes bancarios de clientes del exterior (PDF o captura) se suben directamente a la aplicación, sin pasar por Slack: el bot los lee al subirlos, agrupa en una sola fila los de un mismo pagador (hasta 6 pagos con monto y fecha), se pueden ver los documentos, revisar y enviar a Retorno.",
      "Configuración: se quitó el canal de pagos de Slack, que ya no se usa.",
    ],
  },
  {
    version: "14.15.1",
    date: "2026-10-12",
    items: [
      "Analytics Dashboard: se corrigió la exportación a PDF, que sacaba en blanco los gráficos de Cajas Vendidas, Spot vs Contrato y la tabla de Cajas por Cliente y Semana.",
    ],
  },
  {
    version: "14.15.0",
    date: "2026-10-12",
    items: [
      "Lista de Precios: nuevo botón \"Solicitar ver\" (permiso por usuario). El usuario elige el año y la semana y se envía una solicitud por WhatsApp a quienes se hayan configurado para él en la página de Usuarios.",
      "Cuadro de Precios: nuevo buzón \"Solicitudes\" con las solicitudes para ver precios; se ve la solicitud y se puede aceptarla (abre la semana por 24 horas) o rechazarla. El solicitante recibe la respuesta por WhatsApp.",
      "Usuarios: nueva tarjeta para elegir quién recibe las solicitudes de cada usuario (personal con alertas de WhatsApp activadas), con botón para guardar.",
    ],
  },
  {
    version: "14.14.5",
    date: "2026-10-12",
    items: [
      "Avisar Precios: los usuarios con las alertas de WhatsApp desactivadas (página de Usuarios) ya no aparecen en la lista de destinatarios ni reciben el aviso.",
    ],
  },
  {
    version: "14.14.4",
    date: "2026-10-12",
    items: [
      "Lista de Precios: para usuarios con la restricción de aviso de WhatsApp, el menú Opciones ahora queda habilitado hasta el domingo a las 11:59 pm (hora de Ecuador) de la semana en que se les envió el aviso, en lugar de 48 horas.",
    ],
  },
  {
    version: "14.14.3",
    date: "2026-10-12",
    items: [
      "Lista de Precios: el menú Opciones de una semana, para usuarios con la restricción de aviso de WhatsApp, ahora se habilita solo por 48 horas desde que se les envía el aviso; después vuelve a bloquearse (un nuevo aviso lo reabre).",
    ],
  },
  {
    version: "14.14.2",
    date: "2026-10-12",
    items: [
      "Usuarios: nueva restricción para la Lista de Precios: el menú Opciones solo funciona en las semanas cuyo aviso de WhatsApp (Avisar Precios) se envió a ese usuario.",
    ],
  },
  {
    version: "14.14.1",
    date: "2026-10-12",
    items: [
      "Avisar Precios: la lista de destinatarios ahora incluye a cualquier usuario activo con número de WhatsApp (antes solo aparecía el personal).",
    ],
  },
  {
    version: "14.14.0",
    date: "2026-10-12",
    items: [
      "Cuadro de Precios: nuevo botón \"Avisar Precios\" que envía un WhatsApp avisando que los precios de la semana están listos. Abre una vista previa del mensaje (editable) y una lista para elegir quién lo recibe (personal con número de WhatsApp y grupos); la selección se puede guardar para la próxima vez.",
    ],
  },
  {
    version: "14.13.0",
    date: "2026-10-12",
    items: [
      "Control de Costos (Contenedores, Comisiones, Camiones, Estiba, Paletizado y Evaluaciones): mismo estilo y funciones que Precios de Venta: panel \"Filtros y Acciones\" con botones, filtros por año y semana, y en las listas guardadas rango de semanas, vista previa (Ver) y exportación.",
      "Retorno: nuevo encabezado y panel de Filtros y Acciones como en Precios de Venta, tablas con nuevo diseño y pantalla de carga al abrir la página.",
      "Nuevos estados vacíos, de carga y de hover en toda la aplicación: tablas y listas sin datos más claras, pantalla de carga con mensaje abajo a la derecha y botones que ya no cambian de forma al pasar el mouse.",
      "Las ventanas emergentes y los menús de opciones ahora aparecen con una transición suave.",
    ],
  },
  {
    version: "14.12.8",
    date: "2026-10-08",
    items: [
      "Páginas de listas guardadas (Precios, Compras, Costos y Liquidaciones): el enlace a la página principal en la ruta de navegación solo aparece si el usuario tiene permiso para esa página.",
    ],
  },
  {
    version: "14.12.7",
    date: "2026-10-08",
    items: [
      "Lista de Precios: la vista de detalle (Ver) se rediseñó: más ancha, con resumen arriba, encabezado fijo y columnas alineadas.",
      "Usuarios: más permisos para la Lista de Precios (menú ⋮, tarjetas de resumen, columnas de Promedio, columna Líneas) y una restricción opcional para ver solo la semana anterior.",
      "Usuarios: las secciones del panel de permisos ahora aparecen minimizadas por defecto, con botones para expandir o contraer todas.",
    ],
  },
  {
    version: "14.12.6",
    date: "2026-10-08",
    items: [
      "Gestión Semanal: nuevos botones para las listas guardadas (Lista de Compras, Precios, Costos y Liquidaciones), cada uno con su permiso por usuario.",
      "Usuarios: nuevos permisos para la Lista de Precios (sección de filtros, botón Opciones, Ver, Editar, Exportar y Eliminar) y para Modo Oficina.",
      "Embarques > Importar desde ERP: ya no se bloquean embarques por estar importados en otra semana.",
    ],
  },
  {
    version: "14.12.5",
    date: "2026-10-08",
    items: [
      "En Cierre Semanal ahora se ve si el P&G de la semana ya está guardado: un aviso junto al botón \"Guardar P&G\" (con la fecha y quién lo guardó) y una marca ✓ en las semanas guardadas de la lista.",
      "La sección \"Actualizaciones\" ahora se llama \"Novedades\" y su historial se puso al día.",
    ],
  },
  {
    version: "14.12.0 - 14.12.4",
    date: "2026-10-08",
    items: [
      "Cierre Semanal: nuevo botón \"Guardar P&G\" que guarda el resultado de la semana para el Dashboard del Director; si la semana ya estaba guardada, pide confirmación antes de reemplazarla.",
      "Cierre Semanal: la fuente de datos elegida (Facturación y Compra) ahora se guarda por empresa y semana, y una semana nueva parte de la última elección de esa empresa.",
      "Dashboard del Director: el P&G se lee de lo guardado en Cierre Semanal (carga rápida), semana a semana, con utilidad total y por caja. Solo cuentan las semanas completas y las demás avisan qué les falta.",
      "Dashboard del Director: la tarjeta de Cartera tiene filtro por año, los nombres son los del cliente (no los de facturación) y \"Costos FOB\" se llama ahora \"Costos\".",
      "Dashboard del Director: los detalles de cada sección se abren a pantalla completa y cada uno incluye su gráfico.",
      "Resumen Cartera y Resumen Cuadro: ahora caben en una sola pantalla, con un panel de Filtros y Acciones más ordenado (selector de gráfico, filtros alineados, menú Exportar) y cambio de gráfico con transición suave.",
      "Resumen Cartera por Empresa ahora también muestra Facturación y Cobrado cuando se ven todas las empresas.",
      "Resumen Cartera y Resumen Cuadro cargan mucho más rápido.",
      "Facturador > Auto Fill: cuando el cliente no tiene línea en el Cuadro de Precios, ahora se llenan todos los contenedores del BL (con sus cajas y el mismo precio), no solo el primero.",
    ],
  },
  {
    version: "14.11.0 - 14.11.1",
    date: "2026-10-07",
    items: [
      "Nuevo Dashboard del Director (Reportes & Analítica): una sola pantalla con la bandeja \"Requiere tu atención\" (se marca en rojo cuando algo requiere una decisión), Cartera, Cargas, P&G, Compras y Planificación de la semana actual y la próxima.",
    ],
  },
  {
    version: "14.10.0 - 14.10.2",
    date: "2026-10-07",
    items: [
      "Rastreo: la llegada estimada ahora se calcula con los tiempos típicos de cada ruta (tabla editable en el admin), para que los embarques que ya llegaron hace tiempo no sigan como \"en tránsito\".",
      "Rastreo: solo se siguen y avisan las facturas comerciales (no proformas ni notas de crédito).",
      "Facturador > Auto Fill: ahora usa solo los contenedores del BL elegido y, si el Cuadro de Precios no tiene precio, toma el de Precios Semanales de Venta.",
    ],
  },
  {
    version: "14.8.0 - 14.9.2",
    date: "2026-10-06",
    items: [
      "Rastreo: la llegada se detecta por embarque, hay un agente que busca y asigna los códigos MMSI de los buques, y los embarques ya llegados dejan de rastrearse.",
      "Rastreo: avisos por WhatsApp cuando un embarque llega a su destino (se elige quién los recibe en \"🔔 Avisos\"), y un resumen los viernes a las 2:00 pm de los embarques por llegar. Los mensajes incluyen la semana de cada BL.",
      "Rastreo: por defecto se muestran en el mapa los barcos en tránsito y el estado \"En tránsito\".",
    ],
  },
  {
    version: "14.6.6 - 14.7.1",
    date: "2026-10-06",
    items: [
      "Resumen Cuadro: nuevo diseño igual al Analytics Dashboard, con gráficos combinados que se pueden activar o desactivar (Totales, Precios y Cajas con su diferencia), filtros de semana desde/hasta y exportación a PDF horizontal.",
      "Analytics Dashboard: nuevo filtro \"Pagos\" para excluir semanas de pago de Cobrado y Cartera.",
      "Estados de Cuenta: nuevo modo \"Pagos\" para buscar pagos por año y semana, mostrando la empresa y el cliente (incluye pagos sin fecha).",
    ],
  },
  {
    version: "14.6.0 - 14.6.5",
    date: "2026-10-05",
    items: [
      "Cierre Semanal: se pueden excluir clientes de Facturación y Costos, el panel de Filtros y Acciones se ve como el del Cuadro de Precios y los botones Detalles parpadean (en rojo cuando faltan costos de un cliente).",
      "Costos: nuevo campo \"Comisión de Ventas\" por caja, que también se cuenta en los Costos del Cierre Semanal.",
      "Facturador: se corrigió el desplazamiento de los paneles divididos (Facturador, Packing List y Rastreo).",
      "Empresas y Clientes ahora están en español y Estados de Cuenta tiene su propio permiso por usuario.",
    ],
  },
  {
    version: "9.9.18",
    date: "2026-09-05",
    items: [
      "En Embarques, se agregó la opción de duplicar una fila desde las vistas Buque y Documentos, Consignatario y Destino, y Carga; y se corrigió el ancho de esa columna.",
      "En Embarques, las filas ahora se ordenan por empresa y luego de más reciente a más antiguo.",
      "En Embarques > Semanas Guardadas, el \"Exportar Todo\" a Excel/PDF ahora permite elegir qué empresas incluir y en qué orden (más nuevo a más antiguo o al revés).",
      "Se agregó un botón de opciones con \"Exportar Todo a Excel/PDF\" a las páginas de semanas guardadas de Precios de Venta, Compras, Costos y Liquidaciones Productores (Local).",
      "Se corrigió el error \"número almacenado como texto\" al exportar los Cuadros de Precios, Compras y Costos a Excel.",
      "Se rediseñó Mi Perfil: ahora es más ancho, con la información de la cuenta y el formulario de edición en dos columnas y mejor espaciado entre secciones.",
    ],
  },
  {
    version: "9.9.17",
    date: "2026-07-28",
    items: [
      "Al preguntar cuánto debe un cliente específico, el Asistente de IA ya no repite su nombre en un listado aparte — va directo al detalle semana por semana.",
      "El Asistente de IA ahora puede responder preguntas sobre las facturas generadas: números de factura, buques, número de BL y qué hay registrado en Facturador.",
    ],
  },
  {
    version: "9.9.16",
    date: "2026-07-28",
    items: [
      "Las tarjetas de resumen (Facturas, Cuadro de Precios, Compras y Costos) ahora se ven sólidas en modo claro, con un resplandor de color solo en modo oscuro.",
      "La barra de almacenamiento de Facturas ahora tiene un brillo y un pulso lento que se mueve de un lado a otro.",
    ],
  },
  {
    version: "9.9.15",
    date: "2026-07-28",
    items: [
      "En los Cuadros de Precios, Compras y Costos, el botón para agregar una nueva línea ahora permanece bloqueado hasta que se selecciona una empresa.",
    ],
  },
  {
    version: "9.9.14",
    date: "2026-07-28",
    items: [
      "Los botones de los menús de sección (Admin, Facturación, Gestión Semanal, etc.) ahora son translúcidos en modo oscuro, con un resplandor y borde blancos al pasar el mouse.",
      "El indicador de usuarios en línea ahora parpadea lentamente y es visible sin importar en qué posición esté la barra de navegación (izquierda, derecha, arriba o abajo).",
    ],
  },
  {
    version: "9.9.13",
    date: "2026-07-28",
    items: [
      "Ahora se puede enviar una factura generada directamente por WhatsApp desde el menú de opciones en Facturas, a personal autorizado o grupos registrados, con una vista previa de destinatarios antes de enviar.",
    ],
  },
  {
    version: "9.9.12",
    date: "2026-07-28",
    items: [
      "En Facturador, los botones de Generar Factura, Facturas y Actualizar se agruparon en un solo menú de opciones (⋮).",
      "El botón Actualizar ya no recarga toda la página — solo refresca empresas/clientes/etc. sin borrar lo que ya se había escrito en el formulario.",
      "Los mensajes de error y éxito en Facturador ahora se muestran como una etiqueta con color, en vez de texto plano.",
    ],
  },
  {
    version: "9.9.11",
    date: "2026-07-28",
    items: [
      "Se creó una nueva sección de navegación \"Facturación\", con Facturador Comercial y Facturas.",
      "\"Cierres\" se renombró a \"Gestión Semanal\", y sus páginas se renombraron: Compra Fruta de Productores, Precios de Venta, Costo Unitario por Marca (FOB), Liquidaciones Productores (Local).",
    ],
  },
  {
    version: "9.9.10",
    date: "2026-07-28",
    items: [
      "Se agregó esta sección de Novedades (antes Actualizaciones), con el número de versión actual y el historial de cambios.",
      "Se quitó el número de versión de la página de inicio — ahora se consulta aquí.",
    ],
  },
  {
    version: "9.9.9",
    date: "2026-07-28",
    items: [
      "La pestaña del navegador ahora muestra el nombre de la página en la que estás, en vez de solo \"Sunrise Fruit\".",
    ],
  },
  {
    version: "9.9.8",
    date: "2026-07-28",
    items: [
      "Se corrigió la página de Gestión de Proveedores, a la que le faltaba la miga de pan de navegación.",
      "Se eliminaron 6 páginas antiguas de Proveedores que ya no se usaban, reemplazadas por la página consolidada actual.",
    ],
  },
  {
    version: "9.9.7",
    date: "2026-07-27",
    items: [
      "Se agregó una línea divisoria azul bajo el título de cada sección (Admin, Reportes, Cierres, Control de Costos, Estados de Cuenta) y un efecto de resplandor al pasar el mouse sobre los botones en modo oscuro.",
    ],
  },
  {
    version: "9.9.6",
    date: "2026-07-27",
    items: [
      "Se reorganizó la navegación en menús principales por área (Cierres, Reportes, Control de Costos, Estados de Cuenta, Administración), con migas de pan (breadcrumbs) para saber en qué sección se está.",
      "Se eliminaron páginas antiguas de Proveedores que ya no se usaban.",
    ],
  },
  {
    version: "9.9.5",
    date: "2026-07-27",
    items: [
      "El nuevo Resumen Cuadro ahora permite filtrar por empresa y exportar la vista a PDF.",
    ],
  },
  {
    version: "9.9.4",
    date: "2026-07-27",
    items: [
      "Se agregó al Resumen Cuadro un gráfico de precio promedio semanal (ponderado por cajas), además de los totales.",
    ],
  },
  {
    version: "9.9.3",
    date: "2026-07-27",
    items: [
      "Se creó una nueva página \"Resumen Cuadro\" con gráficos semanales de Precios, Compras y Costos por año.",
    ],
  },
  {
    version: "9.9.1 - 9.9.2",
    date: "2026-07-27",
    items: [
      "El Asistente de Estadísticas con IA ahora presenta las respuestas con mejor formato: encabezados, tablas y listas en vez de texto plano.",
      "En Facturación se muestran los nuevos campos NC y Precio Final junto al precio inicial.",
    ],
  },
  {
    version: "9.9",
    date: "2026-07-27",
    items: [
      "Se corrigió el cálculo del Precio Final en el Cuadro de Precios para que el descuento por Nota de Crédito (NC) se aplique antes de sumar el flete.",
    ],
  },
  {
    version: "9.8.9",
    date: "2026-07-27",
    items: [
      "Se agregó un nuevo campo NC (Nota de Crédito) al Cuadro de Precios, con un Precio Final calculado automáticamente (Precio Inicial - NC).",
      "El Asistente de IA ahora puede responder preguntas sobre el directorio de empresas, clientes por empresa y condiciones de pago.",
    ],
  },
  {
    version: "9.8.6 - 9.8.8",
    date: "2026-07-23",
    items: [
      "El asistente de IA por WhatsApp ahora solo responde cuando se le menciona con \"@collections\" (en chats grupales e individuales), para no interrumpir otras conversaciones.",
      "Las respuestas del asistente por WhatsApp ahora se formatean correctamente (negritas, listas, tablas) en vez de mostrar símbolos de Markdown sin procesar.",
    ],
  },
  {
    version: "9.8.1 - 9.8.5",
    date: "2026-07-22",
    items: [
      "El asistente de IA por WhatsApp ahora también puede responder dentro de grupos de WhatsApp registrados, no solo en mensajes directos al personal.",
    ],
  },
  {
    version: "9.8",
    date: "2026-07-22",
    items: [
      "Se añadió un asistente de inteligencia artificial accesible por WhatsApp: el personal autorizado puede hacer preguntas sobre el negocio directamente por WhatsApp y recibir respuesta del mismo asistente que ya existía en la aplicación web.",
      "Se reforzó la seguridad de este nuevo canal de WhatsApp con una clave secreta de verificación.",
    ],
  },
  {
    version: "9.7.5 - 9.7.9",
    date: "2026-07-22",
    items: [
      "El resumen de pagos pendientes enviado por WhatsApp ahora también puede enviarse en español y permite incluir o excluir clientes con saldo a favor.",
      "El envío del resumen de pagos por WhatsApp ahora adjunta el mismo archivo Excel \"Resumen Combinado\" que se descarga desde la Calculadora de Pagos.",
    ],
  },
  {
    version: "9.7.2 - 9.7.4",
    date: "2026-07-21",
    items: [
      "Ahora se puede enviar el estado de cuenta de un cliente por WhatsApp tanto a miembros del personal como a grupos de WhatsApp registrados.",
      "Se corrigió el ajuste automático del tamaño de letra del título en los PDF de estado de cuenta para que no se superponga con el logo de la empresa.",
    ],
  },
  {
    version: "9.7",
    date: "2026-07-21",
    items: [
      "En Facturación se agregó un campo de descripción adicional para la factura y una sección de \"Observaciones\" que aparece en el documento solo cuando se completa.",
    ],
  },
  {
    version: "9.6",
    date: "2026-07-20",
    items: [
      "Nueva página de administración de Grupos de WhatsApp, para registrar los grupos a los que se pueden enviar reportes.",
      "En Configuración ahora se puede conectar y probar la instancia de WhatsApp usada para enviar reportes y estados de cuenta.",
    ],
  },
  {
    version: "9.5.5 - 9.5.7",
    date: "2026-07-20",
    items: [
      "En el listado de facturas ahora se puede eliminar solo el PDF adjunto (para regenerarlo después) sin borrar el registro completo de la factura, marcándola con la etiqueta \"NO PDF\" cuando falta.",
      "Se corrigió un problema que podía perder una factura si ocurría un error al regenerar su PDF.",
    ],
  },
  {
    version: "9.5.1 - 9.5.4",
    date: "2026-07-20",
    items: [
      "Los selectores de empresa (Cuadro de Precios y similares) ahora tienen un ícono de flecha más claro y ajustes visuales de color.",
    ],
  },
  {
    version: "9.5",
    date: "2026-07-20",
    items: [
      "Al agregar una nueva línea en los Cuadros de Costos, Precios y Compras ahora se puede preseleccionar la empresa antes de crearla.",
    ],
  },
  {
    version: "9.4",
    date: "2026-07-18",
    items: [
      "Se agregó el envío automático de estados de cuenta y resúmenes de pagos pendientes por WhatsApp (además del correo electrónico ya existente).",
      "Los reportes enviados por WhatsApp usan el mismo diseño de PDF que los estados de cuenta por correo.",
    ],
  },
  {
    version: "9.3",
    date: "2026-07-17",
    items: [
      "Los listados de Costos, Precios, Compras y Facturación Local ahora tienen filtros por año y semana en lugar de un solo buscador de texto.",
    ],
  },
  {
    version: "9.2",
    date: "2026-07-16",
    items: [
      "En Facturación se agregó una vista previa de los precios del Cuadro de Precios correspondientes al cliente y semana de la factura.",
      "En Retornos se agregó un menú de \"Opciones\" por fila y se corrigió la posición de las ventanas emergentes de detalle para que no queden tapadas.",
      "Rediseño del interruptor de modo oscuro/claro y ajustes visuales en el menú de navegación.",
      "El Cuadro de Precios ahora permite importar datos desde una plantilla de Excel.",
    ],
  },
  {
    version: "9.1",
    date: "2026-07-14",
    items: [
      "Se agregaron los campos \"Marca\" y \"Embalaje\" al Cuadro de Precios.",
      "Los cuadros de Costos, Precios, Compras y Facturación Local ahora muestran el color de cada empresa para identificarlas más fácilmente.",
      "Se mejoró el diseño de las exportaciones/impresiones de los cuadros de Precios, Costos y Compras.",
    ],
  },
];

export const CURRENT_VERSION = CHANGELOG[0].version;
